import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import './SlugSuggestions.styles.less';

const SlugSuggestions = ({ slugSuggestions, handleLiveUpdateSlug }) => {
  if (isEmpty(slugSuggestions)) {
    return null;
  }

  return (
    <div className="mpr-slug-suggestions">
      <div className="mpr-slug-suggestions__heading">Other suggestions:</div>
      <div className="mpr-slug-suggestions__list">
        {slugSuggestions && slugSuggestions.length > 0 && slugSuggestions.map((suggestion, index) => (
          <span
            key={`mpr-slug-suggestions__item-${index}`}
            className="mpr-slug-suggestions__item"
            onClick={() => handleLiveUpdateSlug(suggestion)}
          >
            {suggestion}
          </span>
        ))}
      </div>
    </div>
  );
};

SlugSuggestions.propTypes = {
  slugSuggestions: PropTypes.arrayOf(PropTypes.string),
  handleLiveUpdateSlug: PropTypes.func
};


export default SlugSuggestions;



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/DropDownForms/UniqueUrlForm/SlugSuggestions/SlugSuggestions.jsx